<template lang="html">
 <v-tooltip top>
  <v-btn
    slot="activator"
    fab
    dark
    fixed
    bottom
    right
    small
    color="primary"
    :href="url"
    target="_blank"
  >
    <v-icon dark>help</v-icon>
  </v-btn>
  <span>Explain this</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "ExplainThis",
  props: ['video'],
  data() {
    return {
        videos: {
          'post-load': 'https://www.youtube.com/watch?v=P9-jViWb5lU'
      }
    }
  },
  computed:{
    url() {
      return this.videos[this.video];
    }
  }
};
</script>

<style lang="css" scoped>

</style>






// WEBPACK FOOTER //
// src/components/ExplainThis.vue